(() => {
  const init = () => {
    // Native forms keep customer data inside Shopify. Only a timestamp/status is remembered here.
    const footerMarker = document.querySelector('[data-footer-welcome]');
    if (footerMarker && footerMarker.dataset.designMode !== 'true') {
      const footerForm = footerMarker.closest('form');
      const footerStorageKey = footerMarker.dataset.storageKey;
      const footerPendingKey = `${footerStorageKey}-footer-pending`;
      try {
        const pendingAt = Number(sessionStorage.getItem(footerPendingKey));
        if (pendingAt > 0 && Date.now() - pendingAt < 10 * 60 * 1000) {
          if (footerForm.querySelector('[data-footer-welcome-posted]')) {
            localStorage.setItem(footerStorageKey, 'subscribed');
            sessionStorage.removeItem(footerPendingKey);
          } else if (footerForm.querySelector('[data-footer-welcome-error]')) {
            sessionStorage.removeItem(footerPendingKey);
          }
        }
      } catch { /* Signup still works when browser storage is unavailable. */ }
      footerForm.addEventListener('submit', () => {
        if (!footerForm.checkValidity()) return;
        try { sessionStorage.setItem(footerPendingKey, String(Date.now())); } catch { /* Optional browser memory. */ }
      });
    }
    const popup = document.querySelector('[data-email-offer]');
    const launcher = document.querySelector('[data-email-offer-launcher]');
    if (!popup || !launcher) return;

    const dialog = popup.querySelector('[data-email-offer-dialog]');
    const form = popup.querySelector('#fumee-email-offer-form');
    const email = popup.querySelector('#fumee-email-offer-email');
    const submit = popup.querySelector('[data-email-offer-submit]');
    const result = popup.querySelector('[data-email-offer-result]');
    const message = popup.querySelector('[data-email-offer-message]');
    const copy = popup.querySelector('[data-email-offer-copy]');
    const storageKey = popup.dataset.storageKey || 'fumee-email-offer-v1';
    const pendingKey = `${storageKey}-pending`;
    const isDesignMode = popup.dataset.designMode === 'true';
    const focusable = 'button:not([disabled]), input:not([disabled]), a[href]';
    let isOpen = false;
    let lastFocus = null;
    let submissionTimer = 0;

    const read = (scope, key) => {
      try { return window[scope].getItem(key); } catch { return null; }
    };
    const write = (scope, key, value) => {
      try { window[scope].setItem(key, value); } catch { /* Storage may be unavailable. */ }
    };
    const remove = (scope, key) => {
      try { window[scope].removeItem(key); } catch { /* Storage may be unavailable. */ }
    };
    let hasSubscribed = !isDesignMode && read('localStorage', storageKey) === 'subscribed';
    launcher.hidden = hasSubscribed;

    const visibleControls = () => [...dialog.querySelectorAll(focusable)].filter((node) =>
      node.type !== 'hidden' && !node.closest('[hidden]') && node.getClientRects().length > 0
    );

    const open = (force = false, showConfirmation = false) => {
      if (isOpen || (hasSubscribed && !showConfirmation) || (!force && read('localStorage', storageKey))) return;
      isOpen = true;
      lastFocus = document.activeElement;
      popup.hidden = false;
      popup.setAttribute('aria-hidden', 'false');
      launcher.hidden = true;
      document.body.classList.add('fumee-email-offer-open');
      requestAnimationFrame(() => {
        popup.classList.add('is-visible');
        (result.hidden ? email : copy)?.focus({ preventScroll: true });
      });
    };

    const close = () => {
      if (!isOpen) return;
      isOpen = false;
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('fumee-email-offer-open');
      launcher.hidden = hasSubscribed;
      if (!isDesignMode && !hasSubscribed && result.hidden) write('localStorage', storageKey, 'dismissed');
      window.setTimeout(() => { if (!isOpen) popup.hidden = true; }, 220);
      const target = lastFocus?.isConnected && lastFocus !== document.body && !lastFocus.closest('[hidden]') && !popup.contains(lastFocus)
        ? lastFocus
        : (!launcher.hidden ? launcher : document.getElementById('MainContent'));
      if (target) {
        const previousTabindex = target.getAttribute('tabindex');
        if (target.tagName === 'MAIN') target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        if (target.tagName === 'MAIN') {
          if (previousTabindex === null) target.removeAttribute('tabindex');
          else target.setAttribute('tabindex', previousTabindex);
        }
      }
    };

    const showResult = () => {
      form.hidden = true;
      popup.querySelector('[data-email-offer-consent]').hidden = true;
      popup.querySelector('[data-email-offer-title]').textContent = 'Your offer is ready.';
      popup.querySelector('[data-email-offer-intro]').textContent = 'Thanks for joining Fumée. Your code is ready to use.';
      result.hidden = false;
      message.textContent = '';
      if (!isDesignMode) {
        hasSubscribed = true;
        launcher.hidden = true;
        write('localStorage', storageKey, 'subscribed');
      }
    };

    popup.querySelectorAll('[data-email-offer-close]').forEach((button) => button.addEventListener('click', close));
    launcher.addEventListener('click', () => open(true));
    window.addEventListener('storage', (event) => {
      if (!isDesignMode && event.key === storageKey && event.newValue === 'subscribed') {
        hasSubscribed = true;
        launcher.hidden = true;
        close();
      }
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isOpen) close();
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') return;
      const controls = visibleControls();
      const first = controls[0];
      const last = controls.at(-1);
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    });

    form?.addEventListener('submit', (event) => {
      if (!form.reportValidity()) {
        event.preventDefault();
        return;
      }
      message.textContent = 'Submitting your email...';
      message.classList.remove('is-error');
      email.removeAttribute('aria-invalid');
      write('sessionStorage', pendingKey, String(Date.now()));
      submit.setAttribute('aria-busy', 'true');
      // Shopify's CAPTCHA may intercept and resubmit the native form; keep the submitter enabled.
      window.clearTimeout(submissionTimer);
      submissionTimer = window.setTimeout(() => {
        submit.removeAttribute('aria-busy');
        message.textContent = 'Your signup is taking longer than expected. Please try again if it does not finish.';
      }, 30000);
    });

    copy?.addEventListener('click', async () => {
      const code = popup.querySelector('[data-email-offer-code]').textContent.trim();
      try {
        await navigator.clipboard.writeText(code);
        copy.textContent = 'Copied';
      } catch {
        copy.textContent = 'Select code to copy';
      }
      window.setTimeout(() => { copy.textContent = 'Copy code'; }, 2400);
    });

    const url = new URL(window.location.href);
    const isReturn = url.searchParams.get('welcome') === '1';
    const error = popup.querySelector('[data-email-offer-error]');
    const posted = popup.querySelector('[data-email-offer-posted]');
    const pendingAt = Number(read('sessionStorage', pendingKey));
    const hasPendingSignup = pendingAt > 0 && Date.now() - pendingAt < 10 * 60 * 1000;
    const confirmed = !!posted || url.searchParams.get('customer_posted') === 'true';
    if (isReturn || (hasPendingSignup && (error || confirmed))) {
      url.searchParams.delete('welcome');
      if (hasPendingSignup) url.searchParams.delete('customer_posted');
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      remove('sessionStorage', pendingKey);
      if (error) {
        message.textContent = error.textContent.trim() || 'Please check your email address and try again.';
        message.classList.add('is-error');
        email.setAttribute('aria-invalid', 'true');
        open(true);
      } else if (hasPendingSignup && confirmed) {
        showResult();
        open(true, true);
      } else {
        message.textContent = 'We could not confirm your signup. Please try again.';
        message.classList.add('is-error');
        open(true);
      }
    } else if (!hasSubscribed && (isDesignMode || !read('localStorage', storageKey))) {
      const delay = Number.parseInt(popup.dataset.delay || '8000', 10);
      window.setTimeout(() => open(), isDesignMode ? 600 : Math.max(0, delay));
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
